import { IPDAdmissionApiState } from '../types/ipdAdmissionSlice.types';

export const IPD_ADMISSION_INITIAL_DATA = {
    id: 0,
    patientId: 0,
    patientVisitId: 0,
    facilityId: 0,
    emrNo: '',
    firstName: '',
    middleName: '',
    lastName: '',
    gender: '',
    dob: '',
    mobilePhoneNo1: '',
    mobilePhoneNo2: '',
    emailAddress: '',
    residentialAddress: '',
    admissionDate: '',
    admissionType: '',
    admissionReason: '',
    provisionalDiagnosis: '',
    admissionStatus: '',
    isFinalized: false,
    createdDate: '',
    createdBy: '',
    updatedDate: null,
    updatedBy: null,
    admissionBeds: [],
    billings: [],
    emergencyContacts: [],
    checklists: [],
};

export const IPD_ADMISSION_INITIAL_STATE: IPDAdmissionApiState = {
    data: {
        list: [],
        totalPages: 0,
        totalRecords: 0,
    },
    pageProps: {
        isDescending: false,
        pageNumber: 0,
        perPage: 0,
        searchText: '',
        sortingOn: '',
    },
    loading: 'idle',
    error: null,
    selectedIPDAdmission: IPD_ADMISSION_INITIAL_DATA,
};
